import { Button } from '@e2n/ui';
import { CancelDialog } from '@/domain/mitarbeiter/features/anlageassistent/components/CancelDialog';
import { MobileHeaderWrapper } from '@/domain/mitarbeiter/features/anlageassistent/components/Header';

import { Navigation } from '@/domain/mitarbeiter/features/anlageassistent/components/Navigation';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { faChevronLeft, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

function DesktopNavigationWrapper() {
  const { t } = useTranslation();
  return (
    <div className="px-8 pt-10 pb-4 bg-backgrounds-secondary h-full sticky top-0">
      <div className="flex flex-col items-start justify-between h-full w-52">
        <Navigation />
        <CancelDialog
          triggerComponent={
            <Button variant="ghost">
              {t('domain.mitarbeiter.create.dialogTrigger')}
            </Button>
          }
        />
      </div>
    </div>
  );
}

function MobileNavigationWrapper() {
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="px-4 py-2 flex items-center justify-between">
      {ctx.hasPrevious() ? (
        <Button variant={'ghost'} onClick={() => ctx.previous()}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
      ) : (
        <div className="size-10" />
      )}
      <MobileHeaderWrapper />
      <CancelDialog
        triggerComponent={
          <Button variant={'ghost'}>
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        }
      />
    </div>
  );
}

export {
  DesktopNavigationWrapper as DesktopNavigation,
  MobileNavigationWrapper as MobileNavigation,
};
